import { useContext } from 'react';

import {
  IconButton,
  IconButtonProps,
  Icons,
  mergeSx,
  Sizes,
} from '@cast/design-system';

import { useRffFormState } from './hooks';
import { RffInputsArrayRowContext } from './inputs-array';

type Props = Omit<IconButtonProps, 'size'> & {
  size?: Sizes<'sm' | 'md'>;
  testId?: string;
  allowRemoveLast?: boolean;
};

const sizeMap: Record<Exclude<Props['size'], undefined>, number> = {
  sm: 16,
  md: 20,
};

export const RemoveInputs = ({
  testId = 'remove-inputs-btn',
  size = 'sm',
  sx,
  allowRemoveLast = false,
  ...iconProps
}: Props) => {
  const { isOnly, remove } = useContext(RffInputsArrayRowContext);
  const { mode } = useRffFormState();
  const isHidden = (allowRemoveLast ? false : isOnly) || mode === 'view';

  return (
    <IconButton
      onClick={
        isHidden
          ? undefined
          : (event) => {
              event.stopPropagation();
              remove();
            }
      }
      size={size}
      variant="ghost"
      data-testid={testId}
      sx={mergeSx(
        {
          display: isHidden ? 'none' : 'inherit',
          ml: 12,
        },
        sx
      )}
      {...iconProps}
    >
      <Icons.X size={sizeMap[size]} weight="regular" />
    </IconButton>
  );
};
